module.exports = __webpack_public_path__ + "static/img/gcon-big-pie.f60f782.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/gcon-big-pie.jpg
// module id = AmZh
// module chunks = 0